import { DatasourceResponse, FormSession } from '../types/form';
import fetchBackend from '@form-engine/core-util/fetch-backend';
import FormEngine from '@form-engine/core-application/index';

export default async function fetchDatasourceBackend(
    formId: string,
    datasourceId: string,
    session: Partial<FormSession>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any,
    options: RequestInit = {}
) {
    const path = FormEngine.datasourceBackendRoute
        .replace(':formId', formId)
        .replace(':datasourceId', datasourceId);

    return fetchBackend(path, session, data, options) || {} as Partial<DatasourceResponse>;
}
